import Highcharts from "highcharts";
import { useMemo } from "react";
import BaseScoringChart from "./BaseScoringChart";

export default function DonutChart({ series, isLoading = false, option, ...props }) {
  const options = useMemo(() => {
    return Highcharts.merge(
      {
        chart: {
          type: "pie",
        },
        title: {
          text: undefined,
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
            innerSize: "90%",
          },
        },
        series: series,
      },
      option
    );
  }, [option, series]);

  return <BaseScoringChart isLoading={isLoading} highcharts={Highcharts} options={options} {...props} />;
}
